import React from 'react'

const OptionalLabel = () => {
  return <span className="font-normal"> (Opcional)</span>
}

export default OptionalLabel
